import { Link, useLocation } from "react-router-dom";

function NoMatch() {

    let location = useLocation();

    return ( 
        <div className="container-fluid center-align column">
            <h3>Stránka <code>{location.pathname}</code> buď neexistuje, nebo na ní nemáš přístup</h3>
            <Link to="/">
              <button
                type="button"
                className="btn btn-primary">
                Zpět na domovskou stránku
              </button>
            </Link>
        </div>
     );
}

export default NoMatch;